import { RouterProvider } from 'react-router';

import { ErrorBoundary, ErrorScreen } from '@/shared/ui';

import { DemoBanner } from './demo/DemoBanner';
import { AppProviders } from './providers/AppProviders';
import { router } from './routes/router';

/**
 * Граница ошибок стоит НАД провайдерами: падение в инициализации Telegram
 * или в самом роутере иначе не поймает никто, и игрок увидит белый экран.
 * Ошибки внутри маршрутов ловит `errorElement` — там ещё можно вернуться
 * на главную, не перезагружая приложение.
 */
export function App() {
  return (
    <ErrorBoundary
      fallback={(error) => (
        <ErrorScreen
          detail={error.message}
          onAction={() => {
            window.location.reload();
          }}
        />
      )}
    >
      <AppProviders>
        <DemoBanner />
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  );
}
